import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
AutoComplete, Input, Col, Row, Radio, Typography, Form } from
"antd";

import { ConsoleLogger } from "@aws-amplify/core";import { isNonHC } from "../../../../shared/helpers";
import './BudgetFilter.css';

const BudgetFilter = React.memo((props) => {
  const [warning, setWarning] = useState(false);
  const [error, setError] = useState(false);
  const [maxForm] = Form.useForm();
  const [minForm] = Form.useForm();
  const [budgetForm] = Form.useForm();
  const { Text } = Typography;
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));

  useEffect(() => {
    if (parseInt(props.budget?.budgetMin) >= parseInt(props.budget?.budgetMax) &&
    props.budget?.budgetMin != null &&
    props.budget?.budgetMax != null &&
    props.budget?.budgetMin != "" &&
    props.budget?.budgetMax != "") {
      setWarning(true);

    } else
    {
      setWarning(false);
    }
  }, [props.budget]);

  useEffect(() => {
    if (props?.budget?.budgetType !== null &&
    props?.budget?.budgetMin !== null &&
    props?.budget?.budgetMax !== null)
    {
      props?.setFilterError && props.setFilterError('');}
  }, [props.budget]);




  useEffect(() => {
    if (props.clear === true) {
      maxForm.resetFields();
      minForm.resetFields();
      // budgetForm.resetFields(); 
    }
  }, [props.clear]);

  const minBudgetValue = (e) => {
    props.setBudget({ ...props.budget, budgetMin: e.target.value });
    props.setClear(false);
  };

  const maxBudgetValue = (e) => {
    props.setBudget({ ...props.budget, budgetMax: e.target.value });
    props.setClear(false);
  };

  const bidRateSelect = (e) => {
    props.setBudget({ ...props.budget, budgetType: e.target.value });
  };

  return (
    <div className="budget-filter-div">
      <Radio.Group onChange={bidRateSelect} value={props.budget?.budgetType}>
        <Radio className="budget-radio-btn" value={"Hour"}>Hourly</Radio>
        {isNonHC(userProfile?.Professions?.ProfessionCode) ? null :
        <Radio className="budget-radio-btn" value={"Week"}>Weekly</Radio>}
        <Radio className="budget-radio-btn" value={"Year"}>Yearly</Radio>
      </Radio.Group> <br />



      <Row className="input-row">
        <Col sm={11} xs={11}>
          <Form
          form={minForm}
          name="min_budget"
          initialValues={{ minBudget: props.budget?.budgetMin }}>
            
            <Form.Item name="minBudget">
              <Input
              prefix={'$'}
              type={'number'}
              className={!warning ? "min-budget-input" : "min-budget-input-red"}
              onChange={minBudgetValue}
              placeholder={"0"}

              value={props.budget?.budgetMin} />
            </Form.Item>
          </Form>
        </Col>

        <Col style={{ textAlign: 'center', paddingTop: '12px' }} sm={2} xs={2}>
          <Text>_</Text>
        </Col>

        <Col sm={11} xs={11}>
          <Form
          form={maxForm}
          name="max_budget"
          initialValues={{ maxBudget: props.budget?.budgetMax }}>
            
            <Form.Item name="maxBudget">
              <Input
              prefix={'$'}
              type={'number'}
              className={!warning ? "min-budget-input" : "min-budget-input-red"}
              onChange={maxBudgetValue}
              placeholder={'0'}
              value={props.budget?.budgetMax} />
            </Form.Item>
          </Form>
        </Col>
      </Row>
      {/* {error ? 
         <div style={{ 
          color: "#db2828", fontSize: "12px", marginTop: "-2%" }}>
            Please select both filters
            </div>
            :
            null} */}
      {warning && <div style={{ color: "#db2828", fontSize: "12px", marginTop: "-2%" }}>Minimum budget cannot be greater than or equal to maximum budget.</div>}
    </div>);

});

export default BudgetFilter;